import styled from 'styled-components'

export const EmptyIconImg = styled.img`
    width: 40%;
`

export const PointerSpan = styled.span`
    cursor: pointer;
`